import Modal from '@/components/Modal/Modal';
import React, { FC } from 'react';
import useIsMobileView from '@/hooks/useIsMobileView';
import Avatar from '@/features/avatar/Avatar';
import CloseModalButton from '@/components/CloseModalButton/CloseModalButton';
import StatCard from '@/pages/agentDashboard/components/StatsCard/StatsCard';
import TetherIcon from '@/features/rewards/Tabs/RedeemTab/components/TetherIcon/TetherIcon';
import DashBoardStatCard from '@/pages/agentDashboard/components/DashBoardStatCard/DashBoardStatCard';
import useGetReferralStatsById from '@/services/rake/queries/useGetReferralStatsById';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';

interface AgentDetailsModalProps {
  userId: string;
  open: boolean;
  setClose: () => void;
}
const ReferralDetailsModal: FC<AgentDetailsModalProps> = ({ userId, open, setClose }) => {
  const { data, isLoading, isFetching, isRefetching } = useGetReferralStatsById({ referralId: userId });

  const isMobileView = useIsMobileView();

  return (
    <Modal
      open={open}
      setClose={setClose}
      bodyClassName="overflow-y-auto w-full scrollbar-phenom"
      className={
        isMobileView
          ? 'h-full w-full'
          : 'max-h-[min(520px,calc(100vh-50px))] min-h-[min(520px,calc(100vh-50px))] min-w-[min(500px,calc(100vw-50px))] max-w-[min(500px,calc(100vw-50px))]'
      }
    >
      <div className="mb flex w-full flex-col gap-8">
        {isLoading || isFetching || isRefetching ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="flex w-full justify-between border-b-[1px] border-ph-white-10 pb-8">
              <div className="flex items-center gap-4">
                <Avatar className="h-24 w-24" userId={userId} round />
                <div className="flex flex-col">
                  <span className="text-xl font-bold text-white">
                    {data?.data.user.firstName} {data?.data.user.lastName}
                  </span>

                  <span className="text-sm font-semibold text-ph-white-50">{data?.data.user.email}</span>
                  <span className="text-sm font-bold text-white">{data?.data.user.alias}</span>
                </div>
              </div>
              <div className="ml-auto">
                <CloseModalButton onClose={setClose} />
              </div>
            </div>
            <div className="rounded-2xl bg-phenom-background-gradient-purple-fade p-6">
              <StatCard
                value={data?.data.totalRevenueShare}
                icon={<TetherIcon width="32" height="32" />}
                title="Total Revenue Earned"
              />
            </div>
            <div className="flex flex-col gap-3">
              <DashBoardStatCard title="Bonus Tokens Earned" total={data?.data.totalTokenEarned} usePhenomIcon />
              <div className="flex gap-3">
                <DashBoardStatCard title="Total Referrals" total={data?.data.totalReferrals} />
                <DashBoardStatCard title="Playing Now" total={data?.data.activeReferrals} />
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ReferralDetailsModal;
